import { set, lensProp, lensPath, pick } from 'ramda';

import {
  REGISTER_FIELD_CHANGE,
  SET_AUTOMATIONS,
  CLEAR_AUTOMATIONS,
  HANDLE_LOADING,
  SET_AUTOMATIONS_ERRORS,
  CLEAR_AUTOMATIONS_ERRORS
} from './constants';

const defaultState = {
  isLoading: false,
  errors: {
    typePrices: null,
    services: null
  },
  submit: {
    typePrices: [],
    services: []
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case REGISTER_FIELD_CHANGE: {
      return set(lensPath(['submit', action.field]), action.value, state);
    }
    case SET_AUTOMATIONS: {
      return set(
        lensProp('submit'),
        pick(['typePrices', 'services'], action.data),
        state
      );
    }
    case HANDLE_LOADING: {
      return set(lensProp('isLoading'), action.status, state);
    }
    case SET_AUTOMATIONS_ERRORS: {
      return {
        ...state,
        errors: {
          typePrices: action.errors?.typePrices ? action.errors?.typePrices[0] : null,
          services: action.errors?.services ? action.errors?.services[0] : null
        }
      }
    }
    case CLEAR_AUTOMATIONS_ERRORS: {
      return set(lensProp('errors'), {}, state);
    }
    case CLEAR_AUTOMATIONS: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
}